import TypeInfoModalContainer from './containers/TypeInfoModalContainer'

export default TypeInfoModalContainer
